import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';

import { serviceurl } from 'src/app/constant/constant';
import { SKIP_ERROR_TOAST } from 'src/app/interceptors/error.interceptor';
import { PaymentIntentResponse, SubscribeResponse } from './marketplace.models';

@Injectable({ providedIn: 'root' })
export class MarketplaceCheckoutService {
  private apiUrl = serviceurl + 'api/v1';

  constructor(private http: HttpClient) {}

  /** Starts (or continues) checkout for the cart, with an optional discount code. */
  createPaymentIntent(coupon?: string | null): Observable<PaymentIntentResponse> {
    // The checkout page shows its own message (empty cart, below minimum).
    return this.http.post<PaymentIntentResponse>(`${this.apiUrl}/checkout/payment-intent/`, coupon ? { coupon } : {}, {
      context: new HttpContext().set(SKIP_ERROR_TOAST, true),
    });
  }

  subscribe(planId: number): Observable<SubscribeResponse> {
    return this.http.post<SubscribeResponse>(`${this.apiUrl}/checkout/subscribe/`, { plan: planId });
  }
}
